import styles from "./Spinner.module.css";

/** A small inline spinner for work in progress; ``label`` is read by screen readers. */
export const Spinner = ({ label }: { label: string }) => (
  <span className={styles.spinner} role="status" aria-label={label} />
);
